import { Pill, type PillKind } from './Pill';

export interface StatusPillProps {
  status: string;
}

const map: Record<string, { label: string; kind: PillKind }> = {
  live: { label: 'Live now', kind: 'live' },
  upcoming: { label: 'Upcoming', kind: 'upcoming' },
  ended: { label: 'Ended', kind: 'ended' },
  draft: { label: 'Draft', kind: 'draft' },
  paid: { label: 'Paid', kind: 'paid' },
  refunded: { label: 'Refunded', kind: 'refunded' },
  partial: { label: 'Partial refund', kind: 'partial' },
  declined: { label: 'Declined', kind: 'declined' },
  pending: { label: 'Pending', kind: 'draft' },
  active: { label: 'Active', kind: 'paid' },
  used: { label: 'Used', kind: 'ended' },
  scheduled: { label: 'Scheduled', kind: 'upcoming' },
  test: { label: 'Test PIN', kind: 'draft' },
};

export function StatusPill({ status }: StatusPillProps) {
  const m = map[status] ?? { label: status, kind: 'ended' as PillKind };
  return <Pill kind={m.kind}>{m.label}</Pill>;
}
